var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{attrs:{"data":_vm.areaCode,"change-on-select":"","filterable":""},on:{"on-visible-change":_vm.onVisibleChange},model:{value:(_vm.placeholders),callback:function ($$v) {_vm.placeholders=$$v},expression:"placeholders"}})}
var staticRenderFns = []

export { render, staticRenderFns }